// extracted by mini-css-extract-plugin
module.exports = {"noCard":"CreateCollection_noCard__Nmvg0","hnpDetails":"CreateCollection_hnpDetails__A3eZU"};